import { connect } from 'react-redux';
import { getJwtToken } from '../../../reducers';
import {
    uploadedFiles,
    removeUploadedFiles,
    updateAfterAction,
    approveAfterAction,
    requestInfoAfterAction,
    updateAndSubmitAfterAction,
    setEventUserAction,
    associateUploadedFile,
    setEventErrorMessage,
    toggleAARequestModal,
    setFormFieldValidity
} from '../../../actions';
import { getEventActions, getEventStatus } from '../../../reducers';
import UploadFiles from '../../../components/event/after-action/upload-files';

const mapStateToProps = state => ({
    jwtToken: getJwtToken(state),
    uploadedFilesArray: state.event.uploadedFiles,
    eventForm: state.event,
    eventActions: getEventActions(state),
    status: getEventStatus(state),
    userInfo: state.data.userInfo,
    hasActions: state.events.hasAfterActionActions,
    userIsCreator: state.events.userIsCreator,
    approvers: state.events.aaApprovers,
    tasks: state.events.aaTasks,
    aaStatus: state.events.aaStatus,
    eventId: state.events.id,
    requestModalActive: state.events.aaRequestModalActive,
    userAction: state.events.userAction,
    afterActionUserID: state.event.EventReport.userId,
    groupStatus: state.events.groupStatus,
    eventState: state.event
});

const mapDispatchToProps = dispatch => ({
    uploadedFiles: object => dispatch(uploadedFiles(object)),
    removeUploadedFiles: (index, data) =>
        dispatch(removeUploadedFiles(index, data)),
    updateAfterAction: data => dispatch(updateAfterAction(data)),
    approveAfterAction: data => dispatch(approveAfterAction(data)),
    requestInfoAfterAction: data => dispatch(requestInfoAfterAction(data)),
    submitAfterAction: data => dispatch(updateAndSubmitAfterAction(data)),
    setEventUserAction: action => dispatch(setEventUserAction(action)),
    associateUploadedFile: data => dispatch(associateUploadedFile(data)),
    setEventErrorMessage: msg => dispatch(setEventErrorMessage(msg)),
    toggleRequestModal: () => dispatch(toggleAARequestModal()),
    setFormFieldValidity: (model, bool) =>
        dispatch(setFormFieldValidity(model, bool))
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UploadFiles);



// WEBPACK FOOTER //
// ./src/containers/event/after-action/upload-files.js